var _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 340,
    viewBox: "0 0 600 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "#0d1b2a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 560,
    height: 300,
    rx: 8,
    fill: "#112240",
    stroke: "#64ffda",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 100,
    fontFamily: "monospace",
    fontSize: 22,
    fill: "#64ffda",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "ServiceOntario AI Chatbot")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 140,
    fontFamily: "monospace",
    fontSize: 13,
    fill: "#8892b0",
    textAnchor: "middle"
  }, "ontario.ca")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 165,
    width: 440,
    height: 2,
    fill: "#64ffda",
    opacity: 0.3
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 200,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#a8b2d8",
    textAnchor: "middle"
  }, "Conversational AI \xB7 UX Research")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 225,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#a8b2d8",
    textAnchor: "middle"
  }, "Voice AI \xB7 AI Governance")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 280,
    r: 6,
    fill: "#64ffda",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 280,
    r: 6,
    fill: "#64ffda",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 280,
    r: 6,
    fill: "#64ffda",
    opacity: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP13);
export default __webpack_public_path__ + "static/media/p13.467ef6cb23d8ad5e7a2b6cef14200e83.svg";
export { ForwardRef as ReactComponent };